import { memo } from 'react';
import classNames from 'classnames';
import { Relationship } from 'src/shared/types/Common';
import styles from '../CaseDetails.module.scss';

interface IPrimaryCaseDetails {
  employeeName: string;
  caseOpenDate: string;
  relationship?: string;
  dependentsFullName: string;
  employeeID: string;
  isExpanded: boolean;
  caseSubTypes: string;
  companyName: string;
}

const PrimaryCaseDetails = ({
  employeeName,
  caseOpenDate,
  relationship = Relationship.Principal,
  dependentsFullName,
  employeeID,
  isExpanded = false,
  caseSubTypes,
  companyName,
}: IPrimaryCaseDetails) => {
  return (
    <>
      <p className={styles['case-content']}>
        <span className={styles['info-label']}>Case Initiated</span>
        <span className={styles['info-value']}>{caseOpenDate}</span>
      </p>

      <p className={`${styles['case-content']} ${styles['bene-details-section']}`}>
        <span className={styles['info-label']}>Beneficiary</span>
        <span className={styles['info-value']}>
          {relationship} - {employeeName} {employeeID && <span>({employeeID})</span>}
          {isExpanded && dependentsFullName && (
            <>
              <span className={styles['beneficiary-dependents-seperator']}>,</span>
              <span>Dependents - {dependentsFullName}</span>
            </>
          )}
        </span>
      </p>

      <p
        className={classNames(styles['case-content'], styles['case-subtypes-section'], {
          'tablet-and-desktop-flex': !isExpanded,
        })}
      >
        <span className={styles['info-label']}>Case Subtypes</span>
        <span className={styles['info-value']}>{caseSubTypes}</span>
      </p>

      <p className={classNames({ 'desktop-only-flex': !isExpanded }, styles['case-content'])}>
        <span className={styles['info-label']}>Company</span>
        <span className={styles['info-value']}>{companyName}</span>
      </p>
    </>
  );
};

export default memo(PrimaryCaseDetails);
